import { Typography } from "@mui/material"
import { useIsDesktop } from "common/MediaQueries"
import ImageContainer from "reusable/wrappers/ImageContainer"
import styled from "styled-components"

const StyledWrapper = styled.div`
  position: relative;
  width: 100%;
`

const StyledTextWrapper = styled.div`
  h1,
  h6,
  h2,
  p {
    color: ${(p) => p.theme.colors.white};
  }
  ${(p) => p.theme.breakpoints.up("md")} {
    width: 800px;
    margin-top: -130px;
    position: relative;
    z-index: 1;
    height: 80px;
    margin-top: -130px;
    max-width: 800px;
    width: 100%;
  }
  ${(p) => p.theme.breakpoints.down("sm")} {
    position: absolute;
    bottom: 30px;
    right: 20px;
  }
  h6 {
    font-weight: 300;
    letter-spacing: 0.03em;
  }
`

type ImageWithTextTypes = {
  image: string
  title: string
  subtitle?: string
}
const ImageWithText = ({ image, title, subtitle }: ImageWithTextTypes) => {
  const isDesktop = useIsDesktop()
  return (
    <>
      <StyledWrapper>
        <ImageContainer src={image} />

        {!isDesktop && (
          <StyledTextWrapper>
            <Typography variant="h2">{title}</Typography>
            <Typography variant="body2">{subtitle}</Typography>
          </StyledTextWrapper>
        )}
      </StyledWrapper>
      <StyledTextWrapper>
        {isDesktop && (
          <>
            <Typography variant="h1">{title}</Typography>
            <Typography variant="subtitle1">{subtitle}</Typography>
          </>
        )}
      </StyledTextWrapper>
    </>
  )
}
export default ImageWithText
